import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
import { MbpService } from 'src/app/services/mbp.service';

@Component({
  selector: 'app-mbp2',
  templateUrl: './mbp2.component.html',
  styleUrls: ['./mbp2.component.css']
})
export class Mbp2Component implements OnInit {

  mbpForm: FormGroup;
  TodayDate: any;
  dateofsellingofinvestmentModel: any;
  showchangeYes: boolean;
  mbsform: any;
  changedropdown: any;
  holder: any;
  restrictTabflag: boolean;
  editParticularId: any;
  editParticularData: any;
  dateOfMakingLoanModel: { month: number; day: number; year: number; };
  dateofmaturityModel: { month: number; day: number; year: number; };
  dateofrepaymentModel: { month: number; day: number; year: number; };
  dateOfPassingBoardResolution: { month: number; day: number; year: number; };
  dateOfPassingResolutionModel: { month: number; day: number; year: number; };
  dateOfSellingOfInvestmentModel: { month: number; day: number; year: number; };
  dateofdisposalModel: { month: number; day: number; year: number; };
  timePeriodFromModel: { month: number; day: number; year: number; };
  timePeriodToModel: { month: number; day: number; year: number; };
  dateofpassingboardresolutionModel: { month: number; day: number; year: number; };
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  disabledOnClick: boolean;

  constructor(private mbpService: MbpService, private activatedRoute: ActivatedRoute,
     private alert: AlertComponent,private router: Router) { }

  ngOnInit() {
    this.mbpForm = new FormGroup({
      natureOfTransaction: new FormControl('', [Validators.required]),
      dateOfMakingLoan: new FormControl('', []),
      nameOfPerson: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(50)]),
      addressOfPerson: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$"), Validators.maxLength(250)]),
      amount: new FormControl('', [Validators.required, Validators.pattern("^[0-9 ,.&-]*$"), Validators.maxLength(20)]),
      timePeriodFrom: new FormControl('', []),
      timePeriodTo: new FormControl('', []),
      rateOfInterest: new FormControl('', [Validators.pattern("^[0-9 .,&%-]*$"), Validators.maxLength(20)]),
      dateOfMaturity: new FormControl('', []),
      dateOfRepayment: new FormControl('', []),
      purposeOfLIGSA: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$")]),
      percentageOfLGSA: new FormControl('', [Validators.pattern("^[0-9 .,&%-]*$"), Validators.maxLength(20)]),
      dateOfPassingBoardResolution: new FormControl('', []),
      dateOfPassingResolutionIfRequired: new FormControl('', []),
      numberOfSecurities: new FormControl('', [Validators.pattern("^[0-9 .,&-]*$"), Validators.maxLength(200)]),
      kindOfSecurities: new FormControl('', [Validators.pattern("^[a-zA-Z ]*$"), Validators.maxLength(200)]),
      nominalValue: new FormControl('', [Validators.pattern("^[0-9 .,&-]*$"), Validators.maxLength(100)]),
      paidUpValue: new FormControl('', [Validators.pattern("^[0-9 .,&-]*$"), Validators.maxLength(100)]),
      classOfSecurities: new FormControl('', [Validators.pattern("^[a-zA-Z ]*$"), Validators.maxLength(200)]),
      costAcquistion: new FormControl('', [Validators.pattern("^[0-9 .,&-]*$"), Validators.maxLength(100)]),
      dateOfSellingOfInvestment: new FormControl('', []),
      sellingPrice: new FormControl('', [Validators.pattern("^[0-9 .,&-]*$"), Validators.maxLength(100)]),
      balanceSecurities: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&-]*$"), Validators.maxLength(100)]),
      clientIdDPno: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&-]*$"), Validators.maxLength(16)]),
      dateOfDisposal: new FormControl('', []),
    });
    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getMbpById(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    })
  }
  showchangeYesClick() {
    this.showchangeYes = true;
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp2List']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  hidechangeyesclick() {
    this.showchangeYes = false;
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getMbpById(particularId) {
    this.mbpService.getMBPDetailsById(particularId).subscribe(response => {
      this.editParticularData = response.data[0];
      this.mbpForm.controls.natureOfTransaction.setValue(this.editParticularData.natureOfTransaction);
      this.mbpForm.controls.nameOfPerson.setValue(this.editParticularData.nameOfPerson);
      this.mbpForm.controls.addressOfPerson.setValue(this.editParticularData.addressOfPerson);
      this.mbpForm.controls.amount.setValue(this.editParticularData.amount);
      this.mbpForm.controls.rateOfInterest.setValue(this.editParticularData.rateOfInterest);
      this.mbpForm.controls.purposeOfLIGSA.setValue(this.editParticularData.purposeOfLIGSA);
      this.mbpForm.controls.percentageOfLGSA.setValue(this.editParticularData.percentageOfLGSA);
      this.mbpForm.controls.numberOfSecurities.setValue(this.editParticularData.numberOfSecurities);
      this.mbpForm.controls.kindOfSecurities.setValue(this.editParticularData.kindOfSecurities);
      this.mbpForm.controls.nominalValue.setValue(this.editParticularData.nominalValue);
      this.mbpForm.controls.paidUpValue.setValue(this.editParticularData.paidUpValue);
      this.mbpForm.controls.classOfSecurities.setValue(this.editParticularData.classOfSecurities);
      this.mbpForm.controls.costAcquistion.setValue(this.editParticularData.costAcquistion);
      this.mbpForm.controls.sellingPrice.setValue(this.editParticularData.sellingPrice);
      this.mbpForm.controls.balanceSecurities.setValue(this.editParticularData.balanceSecurities);
      this.mbpForm.controls.clientIdDPno.setValue(this.editParticularData.clientIdDPno);

      if (this.editParticularData.dateOfMakingLoan != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfMakingLoan));
        this.dateOfMakingLoanModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfMaturity != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfMaturity));
        this.dateofmaturityModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfRepayment != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfRepayment));
        this.dateofrepaymentModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfPassingBoardResolution != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfPassingBoardResolution));
        this.dateofpassingboardresolutionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfPassingResolutionIfRequired != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfPassingResolutionIfRequired));
        this.dateOfPassingResolutionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfSellingOfInvestment != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfSellingOfInvestment));
        this.dateOfSellingOfInvestmentModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfDisposal != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfDisposal));
        this.dateofdisposalModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.timePeriodFrom != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.timePeriodFrom));
        this.timePeriodFromModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.timePeriodTo != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.timePeriodTo));
        this.timePeriodToModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    })
  }

  saveMbp(flag) {
    this.disabledOnClick = true;
    var object = {
      natureOfTransaction: this.mbpForm.controls.natureOfTransaction.value,
      dateOfMakingLoan: this.setDate(this.mbpForm.controls.dateOfMakingLoan.value),
      nameOfPerson: this.mbpForm.controls.nameOfPerson.value,
      addressOfPerson: this.mbpForm.controls.addressOfPerson.value,
      amount: this.mbpForm.controls.amount.value,
      timePeriodFrom: this.setDate(this.mbpForm.controls.timePeriodFrom.value),
      timePeriodTo: this.setDate(this.mbpForm.controls.timePeriodTo.value),
      purposeOfLIGSA: this.mbpForm.controls.purposeOfLIGSA.value,
      percentageOfLGSA: this.mbpForm.controls.percentageOfLGSA.value,
      dateOfPassingBoardResolution: this.setDate(this.mbpForm.controls.dateOfPassingBoardResolution.value),
      dateOfPassingResolutionIfRequired: this.setDate(this.mbpForm.controls.dateOfPassingResolutionIfRequired.value),
      particularId: this.editParticularId
    };
    if (this.mbpForm.controls.natureOfTransaction.value == 'loan') {
      object['rateOfInterest'] = this.mbpForm.controls.rateOfInterest.value;
      object['dateOfMaturity'] = this.setDate(this.mbpForm.controls.dateOfMaturity.value);
      object['dateOfRepayment'] = this.setDate(this.mbpForm.controls.dateOfRepayment.value);
    } else if (this.mbpForm.controls.natureOfTransaction.value == 'investment') {
      object['numberOfSecurities'] = this.mbpForm.controls.numberOfSecurities.value;
      object['kindOfSecurities'] = this.mbpForm.controls.kindOfSecurities.value;
      object['nominalValue'] = this.mbpForm.controls.nominalValue.value;
      object['paidUpValue'] = this.mbpForm.controls.paidUpValue.value;
      object['classOfSecurities'] = this.mbpForm.controls.classOfSecurities.value;
      object['costAcquistion'] = this.mbpForm.controls.costAcquistion.value;
      object['dateOfSellingOfInvestment'] = this.setDate(this.mbpForm.controls.dateOfSellingOfInvestment.value);
      object['sellingPrice'] = this.mbpForm.controls.sellingPrice.value;
      object['balanceSecurities'] = this.mbpForm.controls.balanceSecurities.value;
      object['clientIdDPno'] = this.mbpForm.controls.clientIdDPno.value;
      object['dateOfDisposal'] = this.setDate(this.mbpForm.controls.dateOfDisposal.value);
    }
    if (flag == 'save') {
      this.mbpService.sampleMbsRecord(object).subscribe(response => {
        this.disabledOnClick = false;
        if (response.status == 0) {
          this.alert.successWithOk(response.message, 'mbp2List');
        } else {
          if(response.err_fields){
            this.alert.error(response.err_fields + ' fields are required or invalid.');
          }else{
            this.alert.error(response.message);
          }
        }
      });

    } else if (flag == 'update') {
      this.mbpService.updateMbp(object, this.editParticularId).subscribe(response => {
        this.disabledOnClick = false;
        if (response.status == 0) {
          this.alert.successWithOk(response.message, 'mbp2List');
        } else {
          if(response.err_fields){
            this.alert.error(response.err_fields + ' fields are required or invalid.');
          }else{
            this.alert.error(response.message);
          }
        }
      })
    }
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      // if ((ev.target.value + ev.key).length > 10) {
      //   ev.preventDefault();
      // }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }
  generateOutput() {
    var object = {
      id: this.editParticularId, 
      fromDate: null,
      toDate: null,
      name: null,
      param1: null
    }
    this.mbpService.generateMbpDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.mbpService.downloadMbpFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.mbpService.downloadMbpPdfFile(id, 'Single');
  }

}
